<template>
    <section class="p-5 mt-8 border shadow-sm md:p-7 rounded-3xl border-light_gray bg-white">
        <div class="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
            <div>
                <p class="text-sm font-bold tracking-wider uppercase text-light_green">Árbol taxonómico</p>
                <h2 class="mt-1 text-xl font-bold text-enriqueto_green">Ramas vinculadas con este producto</h2>
                <p class="max-w-3xl mt-2 text-sm leading-relaxed text-gray">
                    Vincula la especie o el último nivel conocido. Enriqueto añadirá automáticamente todos sus términos superiores al árbol público.
                </p>
            </div>
            <Link href="/admin/taxonomy" class="self-start px-4 py-2 text-sm font-bold border rounded-xl border-enriqueto_green text-enriqueto_green">
                Administrar catálogo
            </Link>
        </div>

        <div class="flex flex-col gap-3 mt-5 md:flex-row">
            <select v-model="newTermId" class="flex-1 px-4 py-3 bg-white border rounded-xl border-light_gray">
                <option value="">Selecciona un término</option>
                <option v-for="term in availableTerms" :key="term.id" :value="String(term.id)">
                    {{ term.rank }} — {{ term.name }}
                </option>
            </select>
            <button type="button" class="px-5 py-3 font-bold text-white rounded-xl bg-enriqueto_green" :disabled="!newTermId" @click="addTerm">
                Vincular
            </button>
        </div>

        <div v-if="selectedTerms.length" class="grid gap-3 mt-5 md:grid-cols-2">
            <article v-for="term in selectedTerms" :key="term.id" class="flex items-center justify-between gap-3 p-4 border rounded-2xl border-light_gray bg-light_yellow">
                <div>
                    <span class="text-xs font-bold tracking-wider uppercase text-light_green">{{ term.rank }}</span>
                    <p class="font-bold text-enriqueto_green">{{ term.name }}</p>
                </div>
                <button type="button" class="text-sm font-bold text-red" @click="removeTerm(term.id)">Quitar</button>
            </article>
        </div>
        <p v-else class="p-4 mt-5 text-sm text-center border border-dashed rounded-2xl border-light_gray text-gray">Este producto todavía no tiene una rama taxonómica.</p>

        <div class="flex items-center justify-end gap-3 mt-5">
            <span v-if="message" class="text-sm font-bold text-enriqueto_green">{{ message }}</span>
            <button type="button" :disabled="saving" class="px-5 py-3 font-bold text-white rounded-xl bg-enriqueto_green disabled:opacity-60" @click="save">
                {{ saving ? 'Guardando…' : 'Guardar vínculos' }}
            </button>
        </div>
    </section>
</template>

<script setup>
import axios from 'axios'
import { computed, ref } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps({
    fruitId: { type: Number, required: true },
    terms: { type: Array, default: () => [] },
    assignedTermIds: { type: Array, default: () => [] },
})

const selectedIds = ref(props.assignedTermIds.map(Number))
const newTermId = ref('')
const saving = ref(false)
const message = ref('')

const selectedTerms = computed(() => props.terms.filter(term => selectedIds.value.includes(Number(term.id))))
const availableTerms = computed(() => props.terms.filter(term => !selectedIds.value.includes(Number(term.id))))

function addTerm() {
    const id = Number(newTermId.value)
    if (id && !selectedIds.value.includes(id)) selectedIds.value.push(id)
    newTermId.value = ''
    message.value = ''
}

function removeTerm(id) {
    selectedIds.value = selectedIds.value.filter(selectedId => selectedId !== Number(id))
    message.value = ''
}

async function save() {
    saving.value = true
    message.value = ''
    try {
        await axios.put(`/resource/fruit/${props.fruitId}/taxonomy`, { term_ids: selectedIds.value })
        message.value = 'Árbol taxonómico actualizado.'
    } catch (error) {
        message.value = error.response?.data?.message || 'No se pudieron guardar los vínculos.'
    } finally {
        saving.value = false
    }
}
</script>
